import React, { createContext, useContext, useState, useEffect } from 'react';
import { DB_URL } from '../utils/data';

const DataContext = createContext();

export const DataProvider = ({ children }) => {
    const [data, setData] = useState({ properties: [], interiors: [] });
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await fetch(DB_URL, { cache: 'no-store' });
                if (response.ok) {
                    const jsonData = await response.json();
                    setData({
                        properties: jsonData.properties || [],
                        interiors: jsonData.interiors || []
                    });
                } else {
                    console.error("Failed to fetch data:", response.statusText);
                }
            } catch (error) {
                console.error("Error fetching data:", error);
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, []);

    return (
        <DataContext.Provider value={{ ...data, loading }}>
            {children}
        </DataContext.Provider>
    );
};

export const useData = () => useContext(DataContext);
